<template>
    <div>
        <icon value="edit"></icon>
        <icon value="input" size="tiny"></icon>
        <icon value="input" size="small"></icon>
        <icon value="input" size="medium"></icon>
        <icon value="input" size="large"></icon>
    </div>
</template>

<script>
    /**
     * @example icon demos
     * @for icon
     * @description
     */
    module.exports = {
        components: {
            'icon': require('material-ui-vue/components/icons/icon.vue')
        }
    }
</script>


/** WEBPACK FOOTER **
 ** icon.vue?12d95b98
 **/